import React, { useContext } from 'react';
import { isGreater } from '@/pages/dashboard/pages/overview/_config/common';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';

export default function PlatformMetrics(props: any) {
  const { children,switchData, disableLoading, componentLoadingHight, ...resetProps } = props;
  const { data } = resetProps || {};
  const contextObj = useContext(FilterContext);
  const { filterVal } = contextObj || {};
  const dateDimension = filterVal?.timeType?.toUpperCase() || 'DAY';
  const isChange = isGreater(dateDimension, filterVal?.rangeTime || []);
  const { loading, errorMsg } = data?.keyMetricsData || {};

  const componentItem = (
    // 保证是jsx数组，而不是其他类型数组
    React.Children.map(children, (child: any) => React.cloneElement(
      child,
      {
        ...resetProps,
        data: {...switchData, ...data},
        switchData,
        isChange,
        dateDimension,
        state: {},
        loading,
        error: !!errorMsg
      }
    ))
  );

  return (
    <>
      {(switchData?.cardTitleSwitchVal && disableLoading && !componentLoadingHight)? <div>
        {componentItem}
      </div> : <Abnormal
        isLoading={loading}
        isError={errorMsg}
        style={{ background: '#fff', height: componentLoadingHight ?  componentLoadingHight : (isChange ? 232 : 235 )}}
        component={componentItem}
      />}
      
    </>

  );
};
